module.exports = __webpack_public_path__ + "static/renny-b1a97d81038d0f78b061a3f5ce70ad51.jpg";